// Contact-group vocabulary shared by the tenancy, property and job slideovers.
//
// A slideover lists its tenants and landlords as groups. Every group heading
// counts its members ("Tenants · 2"), and offers one bulk Email pill when
// more than one member is reachable — the inbox Go-to rule: "Email both" for
// two addresses, "Email all" beyond, and no pill at all when only one address
// exists, so it never offers "both" when one tenant has no email. The three
// slideovers must never disagree about when the pill appears.

// Section heading for a contact group: "Tenant" alone, "Tenants · 2" once
// there is a group — the count is what makes "Email both" honest.
export function groupLabel(contacts, one, many) {
  const n = contacts?.length || 0
  if (n === 1) return one
  return n > 1 ? `${many} · ${n}` : many
}

// The pill's label, or null when there is nobody to email "both" of.
export function bulkEmailLabel(contacts) {
  const n = reachable(contacts).length
  if (n < 2) return null
  return n === 2 ? 'Email both' : 'Email all'
}

// One composer addressed to every reachable contact in the group, each on
// its own named chip; the subject is the property, as the row Email buttons
// do. Emailing tenants one row at a time makes two threads out of one
// conversation.
export function emailGroup(contacts, type, subject) {
  const recipients = reachable(contacts).map(c => ({
    email: c.email, name: c.full_name || c.name, type, id: c.id
  }))
  if (!recipients.length) return
  window.openEmail(recipients, { subject })
}

function reachable(contacts) {
  return (contacts || []).filter(c => c?.email)
}
